<template>
    <div id="appRoot" @mouseover="checkHoverPage" @mouseleave="checkHoverPage" >
        <template v-if="$route.meta.public">
            <div id="app">
                <v-app class="cibes" id="login">
                    <router-view/>
                </v-app>
            </div>
        </template>
        <template v-else>
            <v-app class="grey lighten-2" id="inspire">
                <app-drawer class="app--drawer"></app-drawer>
                <app-toolbar class="app--toolbar"></app-toolbar>
                <v-content>
                    <v-container grid-list-md>
                        <!-- Page Header -->
                        <!--<page-header v-if="$route.meta.breadcrumb"></page-header>-->
                        <div class="page-wrapper">
                            <router-view></router-view>
                        </div>
                    </v-container>

                    <!-- App Footer -->
                    <!-- <v-footer class="white pa-3 app--footer" height="auto">
                        <span class="caption"> &copy; {{ new Date().getFullYear() }}</span>
                    </v-footer>-->
                </v-content>
                <!-- Go to top -->
                <app-fab></app-fab>
                <app-dialog></app-dialog>
            </v-app>
        </template>
    </div>
</template>
<script>
import  AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
/*import PageHeader from "@/components/PageHeader";*/
import AppFab from "@/components/AppFab";
import AppDialog from "@/components/AppDialog";
export default {
    components: {
        //PageHeader,
        AppToolbar,
        AppDrawer,
        AppFab,
        AppDialog

    },
    created() {
        setInterval(() => {
            const  dateNow = new Date().getTime(),
                dateCookie = window.$cookies.get("_time"),
                config = 14*24*60*60*1000;
            //console.log( parseInt((dateNow - dateCookie) / 1000));

            if ( dateCookie != null && ((dateNow - dateCookie) > config) ) {
                this.$store.dispatch("auth/logout");
                //clearInterval(myVar);
            }
        }, 1000);
    },
    methods: {
        checkHoverPage() {
            const myToken = window.$cookies.get("jwt");
            if (myToken != null) {
                window.$cookies.set("jwt", myToken, "14d");
                window.$cookies.set("_time", Date.now());
            }
        }
    }
};
</script>
<style scoped>
.cibes {
    background: url("./assets/background.png");
    background-size: cover;
    color: #90979e;
}
.setting-fab {
    top: 50% !important;
    right: 0;
    border-radius: 0;
}
.page-wrapper {
    min-height: calc(100vh - 64px - 50px - 81px);
}
</style>
